module.exports = __webpack_public_path__ + "img/illustration-portable-oxygen.845df0e5.svg";